// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperModal-cls1__8V","cls2":"MultiPaperModal-cls2__63 MultiPaperModal-cls1__8V"};